import { render, staticRenderFns } from "./Wdsc.vue?vue&type=template&id=46bf8c39&scoped=true"
import script from "./Wdsc.vue?vue&type=script&lang=js"
export * from "./Wdsc.vue?vue&type=script&lang=js"
import style0 from "./Wdsc.vue?vue&type=style&index=0&id=46bf8c39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf8c39",
  null
  
)

export default component.exports